import moment from 'moment';
import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import { Button } from '@xsolla/ui-core';
import { useModal } from '@xsolla/ui-modal';

import { useConfig } from '../../../../contexts/config';
import { SpaceBetweenBlock } from '../../../../styled';
import ConnectionsModal from '../../ConnectionsModal';
import { ButtonsWrapper, DateWrapper } from './styleTopRow';

type Props = {
  date?: string;
  projectId: string;
};

const TopRow = ({ date, projectId }: Props): JSX.Element => {
  const intl = useIntl();
  const { xsollaAnalytics } = useConfig();

  const [onOpenModal, onCloseModal] = useModal(() => {
    xsollaAnalytics.sendClick('login_pa_module__dashboard__connections_modal_open', projectId);
    return <ConnectionsModal projectId={projectId} onClose={onCloseModal} />;
  });

  const parsedDate = moment(date).format('L LT');

  return (
    <SpaceBetweenBlock>
      <DateWrapper>
        {intl.formatMessage({ id: 'dashboard.login-card.date' }, { date: parsedDate })}
      </DateWrapper>

      <ButtonsWrapper>
        <Button look="link" palette="brand" onClick={onOpenModal}>
          {intl.formatMessage({ id: 'dashboard.connections.label' })}
        </Button>
      </ButtonsWrapper>
    </SpaceBetweenBlock>
  );
};

export default memo(TopRow);
